import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BaseFilter from '../Base';
import {MultiSelect, PriceRange, PriceGroup, AutocompleteLocation, Pills} from '../../Controls';
import TerritorialDivision from '../../TerritorialDivision/TerritorialDivision';

import { addClassById, removeClassById } from '../../../utils/browser';
import { num2str } from '../../../utils/formater';
import Territory from '../../../classes/geo/territory';
import { VIEW_MODE } from '../../../consts';
import { DEFAULT_EXTEND_FILTER } from '../../../app/Search/filter';

class QuickSearchBase extends BaseFilter {
  constructor (props) {
    super(props);

    this.state = {
      openedExtendFilter: false
    };

    this.territory = new Territory(props.domain);

    this.onSubmit = this.onSubmit.bind(this);
    this.onSubmitMap = this.onSubmitMap.bind(this);
    this.onReset = this.onReset.bind(this);

    /* управление расширенным фильтром */
    this.toggleExtendFilter = this.toggleExtendFilter.bind(this);
    this.onClickExtendFilter = this.onClickExtendFilter.bind(this);
    this.onPressEnterExtendFilter = this.onPressEnterExtendFilter.bind(this);
    this.getCountSelectedExtendFilter = this.getCountSelectedExtendFilter.bind(this);
  }

  /**
   * Перекоючает флаг показа/скрытия расширенного фильтра
   * @param flag
   */
  toggleExtendFilter (flag) {
    this.setState({openedExtendFilter: flag});

    if (flag) {
      addClassById('top-wide-screen', 'hide');
      history.replaceState('', document.title, window.location.pathname + window.location.search + '#filter');
    } else {
      removeClassById('top-wide-screen', 'hide');
      history.replaceState('', document.title, window.location.pathname + window.location.search);
    }
  }

  /**
   * Открывает/закрывает расширенный фильтр
   * @param e
   */
  onClickExtendFilter (e) {
    e.preventDefault();

    this.toggleExtendFilter(!this.state.openedExtendFilter);
  }

  /**
   * Нажатие на Enter в расширенном фильтре
   * @param e
   */
  onPressEnterExtendFilter (e) {
    if (e.key === 'Enter') {
      this.onSubmit();
    }
  }

  componentDidMount () {
    if (window.location.hash === '#filter') {
      this.toggleExtendFilter(true);
    }
  }

  /**
   * Кол-во выбранных параметров в расширенном поиске
   * @returns {*}
   */
  getCountSelectedExtendFilter () {
    return this.props.filter
        .filter((v, k) => DEFAULT_EXTEND_FILTER.has(k))
        .reduce((r, v, k) => r + (v ? 1 : 0), 0);
  }
  // расширенный фильтр

  onSubmit () {
    this.props.onSubmit();
    this.toggleExtendFilter(false);
  }

  onSubmitMap () {
    this.props.onUpdate({
      viewMode: VIEW_MODE.map
    }, this.onSubmit);
  }

  onReset () {
    this.props.onReset();
  }

  renderExtendSearch (ExtendSearch) {
    const selectedCount = this.getCountSelectedExtendFilter();

    const {openedExtendFilter: isOpen} = this.state;
    const {
      user,
      dictionary,
      filter,
      agenciesList,
      offerCount,
    } = this.props;

    const arrowClass = classNames(
      'extend-filter-select-value', 'btn-base', {
        'down': !isOpen,
        'up': isOpen,
        'bandage': selectedCount > 0
      });

    return (
      <div className={'extend-filter-control-box' + (isOpen ? ' open' : '')} onKeyUp={this.onPressEnterExtendFilter}>
        <div className='extend-filter-control-value' onClick={this.onClickExtendFilter}>
          {selectedCount ? <div className='bandage-count'>{selectedCount}</div> : null}
          <button className={arrowClass} type='button'>
            Еще фильтры
          </button>

          { isOpen && <ExtendSearch
            onSubmit={this.onSubmit}
            onReset={this.onReset}
            onUpdate={this.props.onUpdate}
            dictionary={dictionary}
            filter={filter}
            user={user}
            agenciesList={agenciesList}
            offerCount={offerCount}
            onSubmitMap={this.onSubmitMap}
            />
          }

        </div>
      </div>
    );
  }

  renderAutocompleteLocation () {
    const { onUpdate, updateAutocompleteOptions } = this.props;
    return (
      <AutocompleteLocation
        isMapView={this.getValue('viewMode', null) === VIEW_MODE.map}
        selectedOptions={this.getSelectedOptions()}
        onUpdate={onUpdate}
        updateAutocompleteOptions={updateAutocompleteOptions}
      />
    );
  }

  renderPriceRange (toggleEnable, labelToggleOn = 'Цена за м2') {
    return (
      <PriceRange
        priceMin={this.getNumber('priceMin')}
        priceMax={this.getNumber('priceMax')}
        priceUnitId={this.getNumber('priceUnitId')}
        toggleEnable={toggleEnable}
        labelToggleOn={labelToggleOn}
        onUpdate={this.props.onUpdate}
        fireUpdate
      />
    );
  }

  renderPriceGroup (toggleEnable, labelToggle = 'м2.') {
    return (
      <PriceGroup
        priceMin={this.getNumber('priceMin')}
        priceMax={this.getNumber('priceMax')}
        priceUnitId={this.getNumber('priceUnitId')}
        items={toggleEnable ? [
          {type: 'option', value: 1, label: 'руб.'},
          {type: 'option', value: 2, label: labelToggle}
        ] : null}
        onUpdate={this.props.onUpdate}
        fireUpdate
      />
    );
  }

  renderObjectType (dealType, realtyType, placeholder) {
    const items = this.props.dictionary.getObjectTypeItems(dealType, realtyType);

    return (
      <MultiSelect
        items={items}
        name='objectTypeId'
        value={this.getValue('objectTypeId')}
        placeholder={placeholder || 'Тип'}
        onUpdate={this.handlerSelect('objectTypeId')}
      />
    );
  }

  renderTerritorialDivision (realtyType = undefined) {
    const {domain, filter, offerCount} = this.props;

    return (
      !this.territory.isEmpty() &&
        <TerritorialDivision
          domain={domain}
          filter={filter}
          realtyType={realtyType}
          offerCount={offerCount}
          onApply={this.props.onApply}
          onUpdate={this.props.onUpdate} />
    );
  }

  renderSubmit () {
    const count = this.props.offerCount;
    const label = count
        ? `Показать ${count} ${num2str(count, ['объект', 'объекта', 'объектов'])}`
        : 'Найдено 0 объектов';

    return (
      <div className='submit-filter-box'>
        <button onClick={this.onSubmit} className='btn-base btn-hollow btn-primary submit'>
          <span className='short-label'>Найти</span>
          <span className='long-label'>{label}</span>
        </button>
      </div>
    );
  }

  renderSubmitMap () {
    return this.getValue('viewMode') !== VIEW_MODE.map && (
      <div className='submit-filter-box'>
        <button onClick={this.onSubmitMap} className='btn-base btn-hollow base submit-map'>
          <span className="icon icon-map-marker-new"></span>
          На карте
        </button>
      </div>
    );
  }

  renderPills (dealType, realtyType) {
    return this.getValue('viewMode') !== VIEW_MODE.map && (
      <Pills
        dealType={dealType}
        realtyType={realtyType}
        domain={this.props.domain}
        dictionary={this.props.dictionary}
        filter={this.props.prevFilter}
        onUpdateFilter={this.props.onApply}
      />
    );
  }

  renderControlGroup (label, children) {
    return (
      <div className='control-group'>
        <div className='control-label'>{label}</div>
        <div className='controls'>
          {children}
        </div>
      </div>
    );
  }

  renderIsRelease () {
    const isNew = this.getValue('isNewBuilding');
    const isResale = this.getValue('isResale');
    const anyClass = classNames('btn btn-base', { pressed: !isNew && !isResale });
    const releaseClass = classNames('btn btn-base', { pressed: isResale });
    const newClass = classNames('btn btn-base', { pressed: isNew });

    const handler = (key) => {
      return () => {
        const state = {
          isNewBuilding: key === 'new' ? 1 : null,
          isResale: key === 'resale' ? 1 : null,
          deadlineId: null
        };

        this.props.onUpdate(state);
      };
    };

    return this.renderControlGroup('', (
      <div className='btn-group-pills btn-group-new-old' role='group'>
        <button type='button' onClick={handler()} className={anyClass}>Неважно</button>
        <button type='button' onClick={handler('new')} className={newClass}>Новостройки</button>
        <button type='button' onClick={handler('resale')} className={releaseClass}>Вторичное жилье</button>
      </div>
    ));
  }

  render () {
    return null;
  }
}

QuickSearchBase.propTypes = {
  user: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  prevFilter: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,
  offerCount: PropTypes.number,
  agenciesList: PropTypes.object.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  updateAutocompleteOptions: PropTypes.func.isRequired,

  onApply: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired
};

QuickSearchBase.defaultProps = {
  offerCount: 0
};

export default QuickSearchBase;



// WEBPACK FOOTER //
// ./src/ui/Search/QuickSearch/QuickSearchBase.jsx